import axios from 'axios';
import { useEffect, useRef, useState } from 'react';

type ReqMethod = 'get' | 'post' | 'put' | 'patch' | 'delete';
type ReqStatus = 'idle' | 'fetching' | 'fetched';
interface RequestConf {
    method?: ReqMethod;
    url: string;
    data?: unknown;
    params?: object;
    headers?: { [key: string]: string };
    [key: string]: any;
}

function useAxios() {
    const mounted = useRef<boolean>(null);

    const [request, setRequest] = useState<RequestConf | null>(null);

    const [status, setStatus] = useState<ReqStatus>('idle');

    const [data, setData] = useState<unknown | undefined>(undefined);

    const [error, setError] = useState<unknown | undefined>(undefined);

    const reset = (): void => {
        if (status === 'idle') {
            setRequest(null);
            setData(undefined);
            setError(undefined);
        }
    };

    const callApi = async (config: RequestConf) => {
        setStatus('fetching');
        try {
            const response = await axios({
                method: 'get',
                ...config,
            });

            if (mounted.current != null) {

                setData(response.data);
                setStatus('fetched');
            }
        } catch (error: unknown) {
            if (mounted.current != null) {

                setError(error);
            }
        } finally {

            if (mounted.current != null) {

                setStatus('idle');
            }
        }
    };

    useEffect(() => {
        mounted.current = true;
        
        if (request !== null) {
            callApi(request);
        }

        return () => {
            mounted.current = null;
        };
    }, [request]);

    return {
        status,
        data,
        error,
        send: setRequest,
        reset,
    };
}

export { useAxios };
